import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/_current/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LookerSignatureService {
  private readonly http = inject(HttpClient);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLookerSignedUrl(): Observable<any> {
    const url = `${environment.aaptivServiceUrl}/api/v1/looker/signature`;
    return this.http.get(url);
  }
}
